import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastService} from '@app/core/services/toast/toast.service';
import {LotSpecLogicService} from '@app/logic/lot-spec/lot-spec.logic.service';
import {LotsLogicService} from '@app/logic/lots';
import {SearchIndexesLogicService} from '@app/logic/search-indexes/search-indexes.logic.service';
import {BaseDialogFormViewDirective} from '@app/shared/base-views/base-dialog-form-view.directive';
import {ISkinnySpecTemplateDto, SEARCH_INDEX_ENUM} from '@classictechsolutions/hubapi-transpiled-enums';
import {IEnumLookup} from '@classictechsolutions/typescriptenums';
import {orderBy} from 'lodash';
import { take } from 'rxjs';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';

interface IData {
    lotId: number;
}
@Component({
    selector: 'cb-select-lot-template-dialog',
    templateUrl: './select-lot-template-dialog.component.html',
    styleUrls: ['./select-lot-template-dialog.component.scss'],
    standalone: false
})
export class SelectLotTemplateDialogComponent extends BaseDialogFormViewDirective<any, any, any> implements OnInit {
    public static readonly MIN_WIDTH = '1000px';

    public lotId: number;
    public templates: ISkinnySpecTemplateDto[];
    public selectedTemplate: number;
    public indexes: IEnumLookup<number>[];
    constructor(
        public readonly dialogRef: MatDialogRef<SelectLotTemplateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        private readonly toastService: ToastService,
        private readonly lotsLogicService: LotsLogicService,
        private readonly lotSpecsLogicService: LotSpecLogicService,
        private readonly searchIndexesLogic: SearchIndexesLogicService,
        private readonly cbDialog: CbDialogService
    ) {
        super(dialogRef, toastService);
        this.lotId = data.lotId;
    }

    public ngOnInit(): void {
        this.lotsLogicService.$getMappedItem(this.lotId).pipe(take(1)).subscribe(res => this.mappedItem = res);
        this.lotSpecsLogicService.getAvailableSpecTemplates(this.lotId).pipe(take(1)).subscribe((tpls) => {
            this.templates = orderBy(tpls, 'name', 'asc');
        });
    }

    public onSave(): void {
        const ref = this.cbDialog.block('Applying Specification Template...');

        this.lotSpecsLogicService
            .applySpecTemplate(this.lotId, this.selectedTemplate)
            .pipe(take(1))
            .subscribe({
                next: result => {
                    this.mappedItem.specTemplateId = this.selectedTemplate;
                    setTimeout(() => {
                        this.toastSerivce.saveSuccess();
                        this.dialogRef.close(result);
                        ref.close();
                    }, 1000);
                },
                error: error => {
                    console.error('Error applying specification template:', error);
                    this.toastSerivce.showToast(
                        'Failed to apply specification template. Please try again.'
                    );
                    ref.close();
                }
            });
    }
}
